module.exports = function() {
  return new Worker(__webpack_public_path__ + "4465ef46f616032afa20.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./src/services/templateWorker.js
// module id = 2843
// module chunks = 1